import { apiRequest } from "../util/apiUtils";

export const adminDashboard = async (params) => {
  try {
    const res = await apiRequest("get", `dashboard/admin`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};